import { RequireChildrenFor } from "@omni/types/components/utils/children.types";

import { useECommerceProduct } from "@/components/Product/ECommerce/hooks/useECommerceProduct.hook";

type DiscountProps = {};

const DiscountBase = ({ children }: RequireChildrenFor<DiscountProps>) => {
    const { discountPercentage } = useECommerceProduct();
    if (!discountPercentage) return null;

    return <>{children}</>;
};

export { DiscountBase };
